import React, { PropsWithChildren } from 'react'
import { ErrorBoundary, ErrorBoundaryProps } from './error_boundary'

export function ComponentErrorBoundary({
  children,
  ...props
}: PropsWithChildren<ErrorBoundaryProps>) {
  return (
    <ErrorBoundary scope="component" fallback={null} {...props}>
      {children}
    </ErrorBoundary>
  )
}
